import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '../../../shared/components/Button';
import DotsHorizontalIcon from '../../../shared/components/Icon/DotsHorizontalIcon';
import ItemDetailDrawer from './ItemDetailDrawer';
const ActionButton = ({ id }) => {
    const [open, setOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "outline", className: "border-none", onClick: () => setOpen(true), children: _jsx(DotsHorizontalIcon, {}) }), open && id && (_jsx(ItemDetailDrawer, { open: open, onClose: () => setOpen(false), id: id }))] }));
};
export default ActionButton;
